import { AppliedFacets } from '../../facets/models/applied-facets'
import { HttpParams } from '@angular/common/http'

export function parseFacets(facets: AppliedFacets): HttpParams {
  let params = new HttpParams()

  if(!facets)
    return params

  for (let prop in facets)
    prop !== 'type'
      ? params = params.set(`facets[${prop}]`, facets[prop].join('|'))
      : null


  return params
}
